// 英文 UI 文案。仅覆盖界面 chrome；场景名/描述/图标来自后端 SceneMeta。
const en = {
  nav: {
    badge: 'Studio',
    gallery: 'Gallery',
    login: 'Login / Sign up',
    logout: 'Logout',
    debugMode: 'Debug Mode',
  },
  gallery: {
    heroTitle: 'Turn data into scroll-stopping videos.',
    heroHighlight: 'scroll-stopping',
    heroSubtitle: 'Pick a scene, edit the data, export platform-ready MP4.',
    enter: 'Enter',
    myProjects: 'My Projects',
    noProjects:
      'No projects yet. Pick a scene, create, hit 💾 Save in Studio.',
    scenesTitle: 'Scenes',
  },
  auth: {
    loginTitle: 'Login',
    registerTitle: 'Register',
    loginTab: 'Login',
    registerTab: 'Register',
    nickname: 'Name',
    nicknamePh: 'Your name',
    email: 'Email',
    emailPh: 'you@example.com',
    password: 'Password',
    passwordMin8: 'Password (min 8)',
    emailCode: 'Verification code',
    sendCode: 'Send code',
    codePh: '6-digit code',
    loginBtn: 'Login',
    registerBtn: 'Register & Login',
    orEmail: 'or sign up with email',
    googleOnlyHint: 'Continue with Google to start creating',
    googleFail: 'Google login failed',
    sendFail: 'Send failed',
    opFail: 'Operation failed',
  },
  editorPanel: {
    bgColor: 'Background',
    resetBg: 'Reset default',
    data: 'Data',
    exportJson: '⬇ Export JSON',
    importJson: '⬆ Import JSON',
    undo: 'Undo (Ctrl+Z)',
    redo: 'Redo (Ctrl+Shift+Z)',
    aiFill: '✨ AI Fill',
    aiLoginRequired: 'Sign in to use AI Fill',
    aiOverwriteConfirm: 'AI Fill will overwrite the current data with generated content. Continue?',
    aiGenerating: 'Generating… {{count}} chars',
    aiFail: 'AI fill failed',
    close: 'Close editor',
    jsonParseFail: 'JSON parse failed',
  },
  common: {
    back: 'Back',
    undo: 'Undo',
    redo: 'Redo',
    regenerate: 'Regenerate',
    export: 'Export',
    play: 'Play',
    pause: 'Pause',
    loading: 'Loading…',
    save: 'Save',
    cancel: 'Cancel',
    close: 'Close',
    comingSoon: 'Coming soon',
  },
  studio: {
    scenes: 'Scenes',
    preview: 'Preview',
    editor: 'Editor',
    resolution: '1080×1920 · 9:16',
    saved: '✓ Saved',
    saveTitle: 'Save to my projects',
    saveTitlePrompt: 'Project title',
    saveFail: 'Save failed',
  },
  lang: {
    toggle: '中文',
    title: '切换语言',
  },
  export: {
    title: 'Export video',
    platform: 'Platform',
    audio: 'Audio',
    audioNone: 'None',
    watermark: 'Watermark',
    watermarkPlaceholder: '@yourhandle',
    position: 'Position',
    opacity: 'Opacity',
    render: 'Render',
    rendering: 'Rendering…',
    failed: 'Export failed',
    downloading: 'Preparing download…',
    done: 'Export ready',
    browserForce: 'Force browser-side export (debug)',
    serverPath: 'Server render',
    browserPath: 'Browser export',
  },
  feedback: {
    button: 'Feedback',
    title: 'Feedback',
    hint: 'Problems, feature ideas, anything — let us know.',
    placeholder: 'Write your feedback…',
    contactPh: 'Contact (optional, so we can reply)',
    submit: 'Send',
    sending: 'Sending…',
    sent: 'Got it, thanks!',
    fail: 'Failed to send, please try later',
  },
  toast: {
    generating: 'Generating new content…',
    regenerated: 'New content generated',
    undone: 'Undo',
    redone: 'Redo',
    nothingToUndo: 'Nothing to undo',
    nothingToRedo: 'Nothing to redo',
  },
  editor: {
    // 通用
    title: 'Title',
    valueFormat: 'Value format (prefix / suffix / decimals)',
    valuePrefixPh: 'prefix $',
    valueSuffixPh: 'suffix T/B/%',
    timeline: 'Timeline',
    timelineCount: 'Timeline ({{count}} frames)',
    timelineHint: 'Each frame = one year snapshot with comparison items; export races over time.',
    frame: 'Frame',
    item: 'Item',
    deleteFrame: 'Delete frame',
    deleteItem: 'Delete item',
    compareItem: 'Comparison item',
    name: 'Name',
    namePh: 'name',
    value: 'Value',
    valuePh: 'value',
    desc: 'Description',
    descPh: 'description',
    label: 'Label',
    labelPh: 'label',
    color: 'Color',
    emoji: 'Emoji',
    metric: 'Metric',
    metricPh: 'metric',
    // ranking
    items: 'Items',
    itemsCount: 'Items ({{count}})',
    // vs
    left: 'Left',
    right: 'Right',
    // quote
    quote: 'Quote',
    author: 'Author',
    background: 'Background',
    // map
    journeyTitle: 'Journey title',
    subtitle: 'Subtitle',
    routeTheme: 'Route theme',
    mapRegion: 'Map region',
    checkpointsCount: 'Checkpoints ({{count}})',
    city: 'City',
    cityPh: 'city',
    // news
    category: 'Category',
    headlinesCount: 'Headlines ({{count}})',
    headline: 'Headline',
    headlinePh: 'headline',
    source: 'Source',
    sourcePh: 'source',
    time: 'Time',
    timePh: 'time',
    news: 'News',
    // wrapped
    year: 'Year',
    statsCount: 'Stats ({{count}})',
    stat: 'Stat',
    tag: 'Tag',
    tagPh: 'tag',
    // chat
    storyTitle: 'Story title',
    participantsCount: 'Participants ({{count}})',
    participant: 'Participant',
    participantN: 'Participant {{n}}',
    participantEmptyHint: '(add participants first)',
    messagesCount: 'Messages ({{count}})',
    messagesHint: 'Pick a participant as sender; export pops them in order.',
    sender: 'Sender',
    text: 'Text',
    textPh: 'Message content',
    timePlaceholder: 'Time (e.g. 14:32)',
    message: 'Message',
  },
}

export default en
export type Translation = typeof en
